import { type LoaderFunctionArgs } from "react-router";

import {
  DashboardConnectionsDetailsDocument,
  type DashboardConnectionsDetailsQuery,
  type DashboardConnectionsDetailsQueryVariables,
} from "@app_schema";

import { client } from "@application/config/apollo";

import { requireParam } from "@application/hooks/use_required_param";

export const DASHBOARD_CONNECTIONS_DETAILS_LOADER = async (
  props: LoaderFunctionArgs,
) => {
  const { data } = await client.query<
    DashboardConnectionsDetailsQuery,
    DashboardConnectionsDetailsQueryVariables
  >({
    query: DashboardConnectionsDetailsDocument,
    variables: { id: requireParam(props.params, "id") },
  });

  return data;
};
